import { useState, useEffect } from "react"
import { SettingLinks } from "../premiumPaywallCheckout";
import { PaywallAuthErrorCodes, UserDetailsFormData } from "../../../../../global/paywall/paywallInterfaces";
import { getPersonalCustomerDetails, updatePersonalCustomerDetails } from "../../../../../global/paywall/paywallApiUrls";
import * as axios from "axios";
interface PaywallCheckoutPersonalDetailsProps {
    nextStep: () => void
    settingLinks: SettingLinks
    setUserFormData: (data: UserDetailsFormData) => void
}


interface PaywallAccessDataResponse {
    data: {
        id: number;
        email: string;
        firstName: string | null;
        lastName: string | null;
        personalId: string | null;
        phoneNumber: string | null;
    };
    requestId: string;
    error: any;
}


const PaywallCheckoutMobilePersonalDetails = (props: PaywallCheckoutPersonalDetailsProps) => {
    const { nextStep, settingLinks: { terms, privacy,contact }, setUserFormData } = props;
    const [formData, setFormData] = useState<any>({
        email: { id: 1, name: "email", type: "text", label: "", placeholder: '', disabled: true, order: 1, value: "" },
        firstname: { id: 2, name: "firstname", type: "text", placeholder: "*שם פרטי", label: '', order: 2, value: "" },
        lastname: { id: 3, name: "lastname", type: "text", placeholder: "*שם משפחה", label: '', order: 3, value: "" },
        idNumber: { id: 4, name: "idNumber",type: "text", inputmode: "numeric", pattern: "[0-9]*", placeholder: "*מספר תעודת זהות", label: '', value: "", order: 4 },
        phone: { id: 5, name: "phone", label: "", type: "tel", inputmode: "numeric", pattern: "[0-9]*", placeholder: "*מספר טלפון נייד", value: "", order: 5, },
        termsOfuse: {
            id: 6, name: "termsOfuse", type: "checkbox", order: 6,
            label: `מסכים/ה ל<a href="${terms.url}" target="_blank">תנאי השימוש</a>, <a href="${privacy.url}" target="_blank">מדיניות פרטיות</a>, וקבלת פניות שיווקיות כולל טלפוניות. הודעות תפעוליות ימשיכו להישלח בתקופת המינוי גם לאחר הסרתי מרשימת מדוורים.`,
            value: false
        },
    });

    const [errors, setErrors] = useState({});
    const [serverError, setServerError] = useState<string | null>(null);

    const validationSchema = {
        email: {
            required: false,
            message: "שדה חובה",
            validate: (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || "כתובת מייל לא תקינה",
        },
        firstname: {
            required: true,
            message: "שדה חובה",
            validate: (value: string) => {
                if (value.length > 50) return "שם פרטי יכול להכיל עד 50 תווים";
                return /^[A-Za-zא-ת\u0590-\u05FF' ]{2,}$/u.test(value) || "שם פרטי יכול להכיל רק אותיות";
            },
        },
        lastname: {
            required: true,
            message: "שדה חובה",
            validate: (value: string) => {
                if (value.length > 50) return "שם משפחה יכול להכיל עד 50 תווים";
                return /^[A-Za-zא-ת\u0590-\u05FF' ]{2,}$/u.test(value) || "שם משפחה יכול להכיל רק אותיות";
            },
        },
        phone: {
            required: true,
            message: "שדה חובה",
            validate: (value: string) => {
                if (isNaN(Number(value))) {
                    return "מספר טלפון חייב להכיל ספרות בלבד";
                }
                return /^05\d{8}$/.test(value) || "מספר טלפון לא תקין"
            }
        },
        idNumber: {
            required: true,
            message: "שדה חובה",
            validate: (value: string) => {
                if (isNaN(Number(value))) {
                    return "מספר תעודת זהות חייב להכיל ספרות בלבד"
                }
                const isValidIsraeliID = (id: string): boolean => {
                    if (!/^\d{9}$/.test(id)) return false;
                    const idArray = id.split("").map(Number);
                    let sum = 0;
                    for (let i = 0; i < 9; i++) {
                        let num = idArray[i] * (i % 2 === 0 ? 1 : 2);
                        sum += num > 9 ? num - 9 : num;
                    }
                    return sum % 10 === 0;
                };

                return isValidIsraeliID(value) || "תעודת זהות לא תקינה";
            }
        },
        termsOfuse: {
            required: true,
            message: "יש לאשר תנאי שימוש להמשך תהליך הרכישה",
            validate: (value: boolean) => value || "יש לאשר תנאי שימוש להמשך תהליך הרכישה",
        }

    };


    const errorMesssagesServer: Partial<Record<PaywallAuthErrorCodes, string>> = {
        [PaywallAuthErrorCodes.EXISTING_PERSONAL_ID]: `פרטי תעודת הזהות קיימים במערכת.<br /> לבירור צרו קשר עם <a target="_blank" href=${contact.url}>שירות הלקוחות</a>`,
        [PaywallAuthErrorCodes.UNKNOWN_ERROR]: "אירעה שגיאה במערכת, אנא נסו שוב מאוחר יותר",
    }


    const validateField = (name, value) => {
        const schema = validationSchema[name];
        if (!schema) return "";
        if (schema.required) {
            if (typeof value === "boolean" && !value) return schema.message;
            if (typeof value === "string" && !value.trim()) return schema.message;
        }
        if (schema.validate) {
            return typeof schema.validate(value) === "boolean" ? "" : schema.validate(value);
        }
        return "";
    };


    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === "termsOfuse") {
            value = e.target.checked;
        }

        if ((name === "idNumber" || name === 'phone') && isNaN(Number(value))) {
            value = value.replace(/\D/g, "");
            setErrors(({
                [name]: validateField(name, "abc"),
            }));
            return;
        }

        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: { ...prevFormData[name], value },
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: validateField(name, value),
        }));

    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        let newErrors = {};
        let isValid = true;

        Object.keys(formData).forEach((key) => {
            const errorMessage = validateField(key, formData[key].value);
            if (errorMessage) {
                newErrors[key] = errorMessage;
                isValid = false;
            }
        });

        setErrors(newErrors);

        if (!isValid) {
            console.log("Form has errors:", newErrors);
            return;
        }
        setUserFormData({email: formData.email.value, firstName: formData.firstname.value, lastName: formData.lastname.value, phone: formData.phone.value});

        const response = await updateUserData(formData);
        if (response) {
            console.log("Form submitted successfully:", formData);
            nextStep();
        }
    };


    useEffect(() => {
        async function fetchData() {
            const { data } = await getUserData(getPersonalCustomerDetails());
            setFormData(prevFormData => ({
                ...prevFormData,
                email: { ...prevFormData.email, value: data.email },
                firstname: { ...prevFormData.firstname, value: data.firstName || "" },
                lastname: { ...prevFormData.lastname, value: data.lastName || "" },
                idNumber: { ...prevFormData.idNumber, value: data.personalId || "" },
                phone: { ...prevFormData.phone, value: data.phoneNumber || "" },
            }));
        }
        fetchData();
    }, [])

    const getUserData = async (url: string): Promise<PaywallAccessDataResponse> => {
        try {
            const response = await axios.get<PaywallAccessDataResponse>(url);
            return response.data;
        } catch (error) {
            console.error(error);
            setServerError(PaywallAuthErrorCodes.UNKNOWN_ERROR);
        }
    };

    const updateUserData = async (data) => {

        const updatedDetails = {
            details: {
                firstName: data.firstname.value,
                lastName: data.lastname.value,
                personalId: data.idNumber.value,
                phoneNumber: data.phone.value,
                signUpAgreement: data.termsOfuse.value
            }
        };
        try {
            const response = await axios.post(updatePersonalCustomerDetails(), updatedDetails);
            if (response.status === 200) {
                console.log("Data updated successfully");
                return response.data;
            }
        } catch (error) {
            const errorCode = error.response && error.response.data && error.response.data.error && error.response.data.error.errorCode;
            if (errorCode === PaywallAuthErrorCodes.EXISTING_PERSONAL_ID) {
                setServerError(PaywallAuthErrorCodes.EXISTING_PERSONAL_ID);
            } else {
                setServerError(PaywallAuthErrorCodes.UNKNOWN_ERROR);
            }
        }
    };

    return (
        <div className="PaywallCheckoutPersonalDetails">
            <div className="title">פרטי המנוי/ה</div>
            <div className="personal-details-form">
                <form id="checkout-personal-details" onSubmit={handleSubmit}>
                    {Object.entries(formData).map(([fieldKey, inputField]: [string, any]) => {
                        return (
                            <div className={`input-field ${inputField.name}`} key={inputField.id}>
                                <div>
                                    <label dangerouslySetInnerHTML={{ __html: inputField.label }} />
                                    <input
                                        placeholder={inputField.placeholder}
                                        disabled={inputField.disabled}
                                        type={inputField.type}
                                        inputMode={inputField.inputmode}
                                        pattern={inputField.pattern}
                                        name={inputField.name}
                                        value={inputField.value}
                                        onChange={handleChange}
                                        className={errors[fieldKey] ? 'error' : ''}
                                    />
                                </div>
                                <div className="input-field-error">{errors[fieldKey] || inputField.name === 'idNumber' && <span dangerouslySetInnerHTML={{ __html: errorMesssagesServer[serverError] }}  ></span>} </div>
                            </div>
                        );
                    })}
                </form>
                <button form="checkout-personal-details" className="submit-button" type="submit">המשך</button>
            </div>
        </div>
    );
};

export default PaywallCheckoutMobilePersonalDetails;